import axios from 'axios';

function doRequest(method, url, options, config = {}) {
    const handleError = (axiosError) => {
        if (!axiosError || !axiosError.response) {
            const err = new Error(axiosError?.message || 'Network error');
            err.ok = false;
            err.status = 0;
            err.statusText = axiosError?.message || 'Network error';
            err.data = null;
            err.body = null;
            err.isNetworkError = true;
            throw err;
        }
        return processResponse(axiosError.response);
    };

    if (method === 'delete') {
        return axios.delete(url, config)
                    .then(response => processResponse(response))
                    .catch(handleError);
    }

    return axios[method](url, options, config)
        .then(response => processResponse(response))
        .catch(handleError);
}

function processResponse(response) {
    response.status = response.status || 0;
    response.ok = response.status >= 200 && response.status < 300;
    response.statusText = response.statusText || '';
    response.body = response.body || response.data;

    if (typeof response.body === 'string') {
        response.bodyText = response.body;
    } else if (response.body instanceof Blob) {
        response.bodyBlob = response.body;
    } else if (response.body instanceof Object) {
        response.bodyText = JSON.stringify(response.body);
    }

    if (response.ok) return response;

    let error = new Error(response.statusText);
    error.ok = false;
    error.data = response.body;
    error.body = response.body;
    error.status = response.status;
    error.statusText = response.statusText;
    throw error;
}

export default {
    install: (app, options) => {
        app.config.globalProperties.$http = {
            get:    (url, options, config = {}) => {
                return doRequest('get', url, {options}, config)
            },
            post:   (url, options, config = {}) => {
                return doRequest('post', url, options, config)
            },
            put:    (url, options, config = {}) => {
                return doRequest('put', url, options, config)
            },
            delete: (url, config = {}) => {
                return doRequest('delete', url, {}, config)
            },
            patch:  (url, options, config = {}) => {
                return doRequest('patch', url, options, config)
            },
        }
    },
}
